import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-[#0A0F1A] group-[.toaster]:border-[#E2E4E0] group-[.toaster]:shadow-lg group-[.toaster]:rounded-none",
          description: "group-[.toast]:text-[#525C6A]",
          actionButton:
            "group-[.toast]:bg-[#1A2E4A] group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-[#E2E4E0] group-[.toast]:text-[#525C6A]",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
